import { render, staticRenderFns } from "./onePage.vue?vue&type=template&id=18b1a6e1&scoped=true"
import script from "./onePage.vue?vue&type=script&lang=js"
export * from "./onePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b1a6e1",
  null
  
)

export default component.exports